import { Component, Input, Output, EventEmitter } from '@angular/core';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    standalone: false
})
export class WidgetComponent {

    constructor() { }

    loaderState: boolean = false;
    loaderErrorState: boolean = false;

    @Input() widgetObject: any;
    @Input() widgetIndex: number = -1;
    @Output() outputEvents = new EventEmitter<any>();
    @Output() closeWidgetEvent = new EventEmitter<any>();
    @Output() expandWidgetEvent = new EventEmitter<any>();
    @Output() minimizeWidgetEvent = new EventEmitter<any>();
    @Output() fullScreenWidgetEvent = new EventEmitter<any>();
    @Output() nameEditedEvent = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<any>();
    @Output() isReorderableEvent = new EventEmitter<any>();

    expanded: boolean = false;

    changeChartType(text) {
        if (this.widgetObject.chartOptions) {
            this.widgetObject.chartOptions.chartType = text;
        }
    }

    maximizeWidget(clickEvent) {
    }

    closeWidget(index: number) {
        this.closeWidgetEvent.emit(index);
    }

    expandWidget(e) {
        this.expandWidgetEvent.emit({ index: e.index, size: e.size });
        //this.expandWidgetEvent.emit({ index: e.index, colSpan: e.size });
        console.log('expandWidget 2');
    }

    minimizeWidget(e) {
        this.minimizeWidgetEvent.emit({ index: e.index, minimized: e.minimized });
    }

    fullscreenWidget(e) {
        this.fullScreenWidgetEvent.emit({ index: e.index, fullscreen: e.fullscreen });
    }

    nameEdited(e) {
        this.nameEditedEvent.emit({ index: e.index, title: e.title });
    }

    changeLoader(e) {
        this.loaderState = e;
    }

    changeErrorLoader(e) {
        this.loaderErrorState = e;
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit({ 'searchParams': searchParams, 'widgetIndex': this.widgetIndex });
    }

    canDrag(e) {
        this.isReorderableEvent.emit(e);
    }
}
